import React from 'react';
import '../../../assets/css/style.css';

const getIconForButton = (label) => {
    switch(label){
        case 'name':
            return 'btn-icon fa fa-address-book';
        case 'age':
            return 'btn-icon fa fa-birthday-cake';
        case 'gender':
            return 'btn-icon fa fa-venus-mars';
        case 'campus':
            return 'btn-icon fa fa-university';
        case 'picture':
            return 'btn-icon fa fa-picture-o';
        case 'interest':
            return 'btn-icon fa fa-heart';
        default: 
            return 'btn-icon fa fa-address-book';
    }
}

const ProfileButton = ({ label, buttonStyleOn }) => {
    const iconStyles = getIconForButton(label);
    return (
        <div className="nav-button-container">
            <div className="nav-button" style={buttonStyleOn ? {backgroundImage: 'linear-gradient(to top right, #CAC4CC, #F0EBF2, #fff)'} : {backgroundColor: '#fff'}}>
                <i className={iconStyles} aria-hidden="true"></i>
            </div>
            <span className="btn-txt">{label}</span>
        </div>
    );
};

export default ProfileButton;